function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { defineComponent, ref, watch, computed, onMounted, // nextTick,
onBeforeUnmount, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
import { Graph, Arrow, Tooltip } from "@antv/g6";
import { registerCustomNode, shouldBeginDrag, updateStartSignVisible, isNodeTitle } from "./custom-node";
import { registerCustomNodeEdge } from "./custom-edge";
import { registerRemoveEdgeBehavior } from "./remove-edge-behavior";
import { registerLinkEdgeBehavior } from "./link-edge-behavior";
import { GraphMode, GraphStates, resolveGraphData, findGreenEdges, findAllStartNodes, longestPath, NODE_RANKSEP } from "./utils";
import { insertCss } from "insert-css";
import ResizeObserver from "resize-observer-polyfill";
import EditNameDialog from "@pt/components/edit-project-name/dialog.vue";
import FullScreen from "@com/components/player-control/player-fullscreen.vue";
registerRemoveEdgeBehavior();
registerLinkEdgeBehavior();
registerCustomNodeEdge();
insertCss("\n  .g6-component-tooltip {\n    background-color: #333;\n    border-radius: 4px;\n    padding: 8px 12px;\n    box-shadow: none;\n    color: #fff;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    // transform: translateX(-50%);\n    max-width: 254px;\n  }\n\n  // .g6-component-tooltip:after {\n  //   display: block;\n  //   content: '';\n  //   width: 0;\n  //   border-width: 12px 6px 6px 6px;\n  //   border-style: solid;\n  //   border-color: transparent transparent #333 transparent;\n  //   position: absolute;\n  //   top: -18px;\n  //   left: 50%;\n  //   margin-left: -6px;\n  //   z-index: 1000;\n  // }\n");
export default defineComponent({
    name: "UserJourney",
    components: {
        EditNameDialog: EditNameDialog,
        FullScreen: FullScreen
    },
    props: {
        data: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        mode: {
            type: definePropType(String),
            default: GraphMode.Default
        },
        nameEditable: {
            type: Boolean,
            default: true
        },
        // 用户旅程编辑功能
        journeyEditable: {
            type: Boolean,
            default: true
        },
        readonlyReason: definePropType(String)
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var getGraphZoom = function getGraphZoom() {
            var zoom = graph1 === null || graph1 === void 0 ? void 0 : graph1.getZoom();
            return zoom ? zoom * 100 : 0;
        };
        var handleZoomChange = function handleZoomChange(val) {
            graph1 === null || graph1 === void 0 ? void 0 : graph1.zoomTo(val / 100);
            mainZoom.value = val;
        };
        var handleFullScreenChange = function handleFullScreenChange(val) {
            emit("fullscreenchange", val);
        };
        var handleAddZoom = function handleAddZoom(val) {
            var zoom = getGraphZoom() + val;
            if (zoom > 0) {
                graph1 === null || graph1 === void 0 ? void 0 : graph1.zoomTo(zoom / 100);
            } else {
                zoom = 0;
                graph1 === null || graph1 === void 0 ? void 0 : graph1.zoomTo(zoom);
            }
            mainZoom.value = zoom;
        };
        var handleEditNameSubmit = function handleEditNameSubmit(val) {
            var data = getData();
            data.forEach(function(item) {
                if (editNameDialogConfig.value.id === item.id) {
                    item.label = val;
                }
            });
            changeData(data);
            editNameDialogConfig.value.visible = false;
        };
        var rerender = function rerender(nodes, customAttrs) {
            var _$ref;
            var temp = _toConsumableArray(nodes);
            // 编辑模式过滤基础埋点
            if (props.mode === GraphMode.Default) {
                temp = nodes.filter(function(item) {
                    return ![
                        "gs",
                        "impression",
                        "ws"
                    ].includes(item.id);
                });
            }
            var graphData = resolveGraphData(temp);
            graph1 === null || graph1 === void 0 ? void 0 : graph1.changeData(_objectSpreadProps(_objectSpread({}, graphData), {
                nodes: (_$ref = graphData.nodes) === null || _$ref === void 0 ? void 0 : _$ref.map(function(node) {
                    return _objectSpread({}, node, customAttrs);
                })
            }));
            // 重置属性值，影响上面的步骤
            graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes().forEach(function(node) {
                graph1 === null || graph1 === void 0 ? void 0 : graph1.updateItem(node, customAttrs);
            });
            graph1 === null || graph1 === void 0 ? void 0 : graph1.render();
            clearStates();
            validate();
            updateStartNodeSign();
        };
        var validateEmptyNodes = function validateEmptyNodes(nodes) {
            emptyNodeError.value = nodes.length <= 0;
        };
        var changeData = // 设置数据
        function changeData(nodes) {
            // 判断nodes数量，低于1个节点提示无配置action
            validateEmptyNodes(nodes);
            rerender(nodes, nodeCustomAttrs.value);
        };
        var getData = // 获取数据
        function getData() {
            var _$ref;
            return (_$ref = graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes().map(function(node) {
                var _data;
                var nodeData = (_data = node.getModel().data) !== null && _data !== void 0 ? _data : {};
                return _objectSpreadProps(_objectSpread({
                    // @ts-ignore
                    id: node.getID()
                }, nodeData), {
                    edges: node.getOutEdges().map(function(edge) {
                        return edge.getTarget().getID();
                    })
                });
            })) !== null && _$ref !== void 0 ? _$ref : [];
        };
        var getEdges = // 获取边
        function getEdges() {
            var _$ref;
            return (_$ref = graph1 === null || graph1 === void 0 ? void 0 : graph1.getEdges().map(function(edge) {
                return {
                    id: edge.getID(),
                    source: edge.getSource().getID(),
                    target: edge.getTarget().getID()
                };
            })) !== null && _$ref !== void 0 ? _$ref : [];
        };
        var validate = function validate() {
            var allStartNodes = findAllStartNodes(getData());
            var flag = allStartNodes.length > 1;
            validateError.value = flag;
            return !flag;
        };
        var updateStartNodeSign = function updateStartNodeSign() {
            var allStartNodes = findAllStartNodes(getData());
            graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes().forEach(function(node) {
                updateStartSignVisible(allStartNodes.some(function(startNode) {
                    return startNode.id === node.getID();
                }), node);
            });
        };
        var clearStates = function clearStates(ignoreItems) {
            var isIgnore = function(target) {
                return Boolean(ignoreItems && ignoreItems.some(function(item) {
                    return item.getID() === target.getID();
                }));
            };
            graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes().forEach(function(node) {
                if (isIgnore(node)) {
                    return;
                }
                graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(node);
            });
            graph1 === null || graph1 === void 0 ? void 0 : graph1.getEdges().forEach(function(edge) {
                if (isIgnore(edge)) {
                    return;
                }
                graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(edge);
            });
            if (props.mode === GraphMode.Readonly) {
                var allEdges = graph1 === null || graph1 === void 0 ? void 0 : graph1.getEdges();
                var greenEdges = findGreenEdges(getData());
                greenEdges.forEach(function(edge) {
                    var targetEdge = allEdges === null || allEdges === void 0 ? void 0 : allEdges.find(function(e) {
                        return e.getSource().getID() === edge.source && e.getTarget().getID() === edge.target;
                    });
                    if (targetEdge) {
                        graph1 === null || graph1 === void 0 ? void 0 : graph1.setItemState(targetEdge, GraphStates.Highlight, true);
                        targetEdge.toFront();
                    }
                });
            }
        };
        var bindCreateEdgeEvents = // see: https://github.com/antvis/G6/blob/master/packages/site/examples/interaction/createEdge/demo/drag-link-point.js
        function bindCreateEdgeEvents(graph) {
            var onAfteradditem = function(e) {
                if (e.item && e.item.getType() === "edge") {
                    graph === null || graph === void 0 ? void 0 : graph.updateItem(e.item, {
                        sourceAnchor: 1
                    });
                    var selectedNodes = graph.findAllByState("node", GraphStates.Selected);
                    clearStates(selectedNodes);
                    graph === null || graph === void 0 ? void 0 : graph.clearItemStates(e.item);
                    graph === null || graph === void 0 ? void 0 : graph.setItemState(e.item, GraphStates.Hover, true);
                }
            };
            graph.on("afteradditem", onAfteradditem);
            var onAfterRemoveitem = function(e) {
                unbind();
            };
            graph.on("afterremoveitem", onAfterRemoveitem);
            function unbind() {
                graph.off("afteradditem", onAfteradditem);
                graph.off("afterremoveitem", onAfterRemoveitem);
            }
            return unbind;
        };
        var relayout = function relayout() {
            var _$ref2;
            var size = nodeCustomAttrs.value.size;
            var nodes = graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes();
            var groupByX = {};
            nodes === null || nodes === void 0 ? void 0 : nodes.forEach(function(node) {
                var x = node.getBBox().x;
                var group = groupByX[x];
                if (!group) {
                    group = groupByX[x] = [];
                }
                group.push(node);
            });
            var longestPathIds = longestPath(getData());
            var _y;
            var baseY = (_y = (_$ref2 = graph1 === null || graph1 === void 0 ? void 0 : graph1.findById(longestPathIds[0])) === null || _$ref2 === void 0 ? void 0 : _$ref2.getBBox().y) !== null && _y !== void 0 ? _y : 0;
            longestPathIds.forEach(function(id) {
                var node3 = graph1 === null || graph1 === void 0 ? void 0 : graph1.findById(id);
                if (!node3) {
                    return;
                }
                var x = node3.getBBox().x;
                var group = groupByX[x];
                group === null || group === void 0 ? void 0 : group.sort(function(node1, node2) {
                    return node1.getBBox().y - node2.getBBox().y;
                });
                var targetIndex = group === null || group === void 0 ? void 0 : group.findIndex(function(node) {
                    return node.getID() === id;
                });
                if (typeof targetIndex === "number" && targetIndex > -1) {
                    var _$ref, _$ref1;
                    var height = (_$ref1 = ((_$ref = typeof size === "number" ? [
                        size,
                        size
                    ] : size) !== null && _$ref !== void 0 ? _$ref : [])[1]) !== null && _$ref1 !== void 0 ? _$ref1 : 0;
                    group === null || group === void 0 ? void 0 : group.forEach(function(currentNode, index) {
                        currentNode.updatePosition({
                            x: x,
                            y: (index - targetIndex) * (height + NODE_RANKSEP) + baseY
                        });
                    });
                } else {
                    node3.updatePosition({
                        x: x,
                        y: baseY
                    });
                }
            });
            graph1 === null || graph1 === void 0 ? void 0 : graph1.getEdges().forEach(function(e) {
                return e.refresh();
            });
            graph1 === null || graph1 === void 0 ? void 0 : graph1.fitView([
                hasAlert.value ? 36 : 0,
                0,
                0,
                0
            ]);
            focusLinkedNodes();
            mainZoom.value = getGraphZoom();
        };
        var focusLinkedNodes = function focusLinkedNodes() {
            var nodes = graph1 === null || graph1 === void 0 ? void 0 : graph1.getNodes();
            var _$ref;
            var needFocusNodes = (_$ref = nodes === null || nodes === void 0 ? void 0 : nodes.filter(function(node) {
                return node.getEdges().length > 0;
            })) !== null && _$ref !== void 0 ? _$ref : [];
            if (props.mode === GraphMode.Readonly && needFocusNodes.length > 0) {
                var _items;
                var items1 = needFocusNodes.reduce(function(items, node) {
                    return (_items = items).concat.apply(_items, [
                        node
                    ].concat(_toConsumableArray(node.getEdges())));
                }, []);
                graph1 === null || graph1 === void 0 ? void 0 : graph1.focusItems(items1, true, true, {
                    easing: "easeQuadOut",
                    duration: 500
                });
            }
        };
        var handleAdapter = function handleAdapter() {
            relayout();
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var containerRef = ref();
        var nodeType = computed(function() {
            return props.mode === GraphMode.Default ? "rect" : "card";
        });
        var nodeCustomAttrs = computed(function() {
            return {
                nodeType: nodeType.value,
                size: nodeType.value === "rect" ? [
                    288,
                    48
                ] : [
                    288,
                    172
                ],
                readonly: props.mode === GraphMode.Readonly
            };
        });
        var validateError = ref(false);
        var emptyNodeError = ref(false);
        var showValidateErrorAlert = computed(function() {
            return props.mode === GraphMode.Default && validateError.value;
        });
        var showReadonlyReasonAlert = computed(function() {
            return props.mode === GraphMode.Readonly && props.readonlyReason;
        });
        var hasAlert = computed(function() {
            return showValidateErrorAlert.value || showReadonlyReasonAlert.value;
        });
        var graph1 = null;
        var observer = null;
        var mainZoom = ref(0);
        var editNameDialogConfig = ref({
            title: "\u8282\u70B9\u540D\u79F0",
            visible: false,
            name: "",
            id: "",
            rules: [],
            params: {}
        });
        onMounted(function() {
            var container = containerRef.value;
            observer = new ResizeObserver(function(e) {
                var rect = container.getBoundingClientRect();
                graph1 === null || graph1 === void 0 ? void 0 : graph1.changeSize(rect.width, rect.height);
                focusLinkedNodes();
            });
            observer.observe(container);
            var edgeStyles = function(style) {
                return _objectSpread({
                    radius: 8,
                    stroke: style.color,
                    lineWidth: 2,
                    lineAppendWidth: 14,
                    endArrow: {
                        path: Arrow.triangle(12, 12, -1),
                        fill: style.color,
                        strokeOpacity: 0
                    }
                }, style);
            };
            var nodeTitletooltip = new Tooltip({
                offsetX: 0,
                offsetY: 20,
                getContent: function getContent(e) {
                    var target = e === null || e === void 0 ? void 0 : e.target;
                    if (target && isNodeTitle(target)) {
                        var sourceText = target.attr("sourceText");
                        return sourceText;
                    }
                    return " ";
                },
                shouldBegin: function(e) {
                    var target = e === null || e === void 0 ? void 0 : e.target;
                    if (target && isNodeTitle(target)) {
                        var text = target.attr("text");
                        var sourceText = target.attr("sourceText");
                        return text !== sourceText;
                    }
                    return false;
                }
            });
            var edgeTooltip = new Tooltip({
                offsetX: 0,
                offsetY: 20,
                // fixToNode: [1, 0],
                getContent: function getContent(e) {
                    var _$ref;
                    var _item = e === null || e === void 0 ? void 0 : e.item;
                    if (!_item) return "";
                    var item = _item;
                    var data = getData();
                    var sourceNode = data.find(function(node) {
                        return node.id === item.getSource().getID();
                    });
                    var edgeInfo = sourceNode === null || sourceNode === void 0 ? void 0 : (_$ref = sourceNode.nexts) === null || _$ref === void 0 ? void 0 : _$ref[item.getTarget().getID()];
                    return "\n          <div>".concat(root.$t("userJourney.fields.flows"), " ").concat((edgeInfo === null || edgeInfo === void 0 ? void 0 : edgeInfo.flows) || "-", "<div>\n            <div>").concat(root.$t("userJourney.fields.duration"), " ").concat((edgeInfo === null || edgeInfo === void 0 ? void 0 : edgeInfo.timing) ? "".concat(Number((edgeInfo.timing / 100).toFixed(0)) / 10, "s") : "-", "<div>\n            ");
                },
                shouldBegin: function(e) {
                    return props.mode === GraphMode.Readonly;
                },
                itemTypes: [
                    "edge"
                ]
            });
            var createEdgeEventsUnbind = null;
            var _obj, _obj1, _obj2;
            graph1 = new Graph({
                container: container,
                fitViewPadding: 0,
                fitView: true,
                animate: true,
                minZoom: 0.1,
                maxZoom: 1,
                plugins: [
                    nodeTitletooltip,
                    edgeTooltip
                ],
                // see: https://g6-v4.antv.vision/api/graph-layout/dagre
                layout: {
                    type: "dagre",
                    align: "UL",
                    // 从左至右布局
                    rankdir: "LR",
                    // 是否保留布局连线的控制点
                    controlPoints: true
                },
                defaultEdge: {
                    type: "custom-edge",
                    style: edgeStyles({
                        color: "#C6C6C6"
                    })
                },
                edgeStateStyles: (_obj = {}, _defineProperty(_obj, GraphStates.Selected, edgeStyles({
                    color: "#F3AD02",
                    shadowColor: "",
                    shadowBlur: 0
                })), _defineProperty(_obj, GraphStates.Hover, edgeStyles({
                    color: "#FFDA99"
                })), _defineProperty(_obj, GraphStates.Actived, edgeStyles({
                    color: "#F5BD35"
                })), _defineProperty(_obj, GraphStates.Highlight, edgeStyles({
                    color: "#52C41A"
                })), _obj),
                defaultNode: {
                    type: "custom-node"
                },
                nodeStateStyles: (_obj1 = {}, _defineProperty(_obj1, GraphStates.Selected, {
                    stroke: "#F3AD02",
                    strokeOpacity: 1
                }), _defineProperty(_obj1, GraphStates.Actived, {
                    stroke: "#F5BD35",
                    strokeOpacity: 1
                }), _defineProperty(_obj1, GraphStates.Hover, {
                    stroke: "#FFCA70",
                    strokeOpacity: 1
                }), _obj1),
                modes: (_obj2 = {}, _defineProperty(_obj2, GraphMode.Default, [
                    "drag-canvas",
                    "zoom-canvas",
                    "remove-edge",
                    {
                        type: "link-edge",
                        trigger: "drag",
                        shouldBegin: function(e) {
                            var should = !shouldBeginDrag(e.target);
                            if (should) {
                                createEdgeEventsUnbind = bindCreateEdgeEvents(graph1);
                            }
                            return should;
                        },
                        shouldEnd: function(e) {
                            var sourceNode = e.sourceNode;
                            var targetNode = e.item;
                            createEdgeEventsUnbind === null || createEdgeEventsUnbind === void 0 ? void 0 : createEdgeEventsUnbind();
                            createEdgeEventsUnbind = null;
                            if (sourceNode && targetNode && sourceNode.getID() !== targetNode.getID()) {
                                var edges = targetNode.getInEdges();
                                graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(targetNode, GraphStates.Actived);
                                return !edges.some(function(edge) {
                                    return edge.getSource().getID() === sourceNode.getID();
                                });
                            }
                            return false;
                        }
                    },
                    {
                        type: "drag-node",
                        shouldBegin: function(e) {
                            return shouldBeginDrag(e.target);
                        }
                    }, 
                ]), _defineProperty(_obj2, GraphMode.Readonly, [
                    {
                        type: "drag-canvas",
                        allowDragOnItem: true
                    },
                    "zoom-canvas", 
                ]), _obj2)
            });
            registerCustomNode({
                t: function(k) {
                    return root.$t(k).toString();
                },
                nameEditable: props.nameEditable
            });
            watch(function() {
                return props.mode;
            }, function(mode) {
                graph1 === null || graph1 === void 0 ? void 0 : graph1.setMode(mode);
            }, {
                flush: "sync",
                immediate: true
            });
            watch(function() {
                return nodeCustomAttrs.value;
            }, function(attrs) {
                var data = getData();
                rerender(data, attrs);
            }, {
                flush: "sync"
            });
            changeData(props.data);
            graph1.on("wheelzoom", function(evt) {
                mainZoom.value = getGraphZoom();
            });
            // Node events
            graph1.on("node:mouseenter", function(evt) {
                var item = evt.item;
                if (item) {
                    graph1 === null || graph1 === void 0 ? void 0 : graph1.setItemState(item, GraphStates.Hover, true);
                }
            });
            graph1.on("node:mouseleave", function(evt) {
                var item = evt.item;
                if (item) {
                    graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(item, GraphStates.Hover);
                }
            });
            graph1.on("node:click", function(evt) {
                var item = evt.item;
                if (evt.target.cfg.name === "edit-button") {
                    // 点击名称修改
                    console.log("\u70B9\u51FB\u540D\u79F0\u4FEE\u6539", item === null || item === void 0 ? void 0 : item.getModel().data);
                    var data = item === null || item === void 0 ? void 0 : item.getModel().data;
                    if (data) {
                        editNameDialogConfig.value.visible = true;
                        editNameDialogConfig.value.id = data.id;
                        editNameDialogConfig.value.name = data.label;
                    }
                // if (data) {
                //   const nodeList = getData()
                //   changeData(nodeList)
                // }
                // const node = graph?.findById(evt.item?.getID()) as Node
                // const temp = item?.getModel().data as UserJourneyNode
                // if (temp) temp.label = '888'
                // graph?.updateItem(item, { data: temp })
                // item?.refresh()
                // item.cfg.attrs.nodeData.label = 888
                // graph?.findById(evt.item?.getID()).refresh()
                // emit('editActionName', evt.target.cfg.attrs.nodeData)
                } else {
                    if (!props.journeyEditable) {
                        return;
                    }
                    if (!item || !graph1 || item.hasState(GraphStates.Selected)) return;
                    clearStates();
                    graph1.setItemState(item, GraphStates.Selected, true);
                    // 需要选中节点出去的线
                    // 获取与 node 关联的所有出边
                    var edges = item.getOutEdges();
                    edges.forEach(function(edge) {
                        graph1 === null || graph1 === void 0 ? void 0 : graph1.setItemState(edge, GraphStates.Actived, true);
                        edge.toFront();
                    });
                }
            });
            // Edge events
            graph1.on("edge:mouseenter", function(evt) {
                var item = evt.item;
                if (item) {
                    graph1 === null || graph1 === void 0 ? void 0 : graph1.setItemState(item, GraphStates.Hover, true);
                    item.toFront();
                }
            });
            graph1.on("edge:mouseleave", function(evt) {
                var item = evt.item;
                if (item) {
                    graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(item, GraphStates.Hover);
                }
            });
            graph1.on("edge:click", function(evt) {
                var item = evt.item;
                clearStates();
                item && (graph1 === null || graph1 === void 0 ? void 0 : graph1.setItemState(item, GraphStates.Selected, true));
            });
            graph1.on("afterlinkedge", function(e) {
                e.edge && (graph1 === null || graph1 === void 0 ? void 0 : graph1.clearItemStates(e.edge));
                validate();
                updateStartNodeSign();
            });
            graph1.on("afterremoveedge", function() {
                validate();
                updateStartNodeSign();
            });
            // Graph Events
            graph1.on("canvas:click", function(evt) {
                clearStates();
            });
            graph1.on("afterrender", function(e) {
                relayout();
            });
        });
        onBeforeUnmount(function() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            graph1 === null || graph1 === void 0 ? void 0 : graph1.destroy();
        });
        return {
            // Alert
            showReadonlyReasonAlert: showReadonlyReasonAlert,
            showValidateErrorAlert: showValidateErrorAlert,
            editNameDialogConfig: editNameDialogConfig,
            GraphMode: GraphMode,
            containerRef: containerRef,
            validateError: validateError,
            emptyNodeError: emptyNodeError,
            mainZoom: mainZoom,
            // Methods
            changeData: changeData,
            getData: getData,
            getEdges: getEdges,
            validate: validate,
            handleEditNameSubmit: handleEditNameSubmit,
            handleZoomChange: handleZoomChange,
            handleAddZoom: handleAddZoom,
            handleAdapter: handleAdapter,
            handleFullScreenChange: handleFullScreenChange
        };
    }
});
